import { ABMGenerico } from "src/general_components/ABMGenerico";
import IconButton from '@mui/material/IconButton'; // Botón para íconos con funcionalidad de clic
import Tooltip from '@mui/material/Tooltip'; // Para mostrar el tooltip sobre el ícono
import { Grid } from "@mui/material";
import { SimpleDialogComponent } from "src/general_components/SimpleDialogComponent";
import { useState } from "react";
import { RolesPerfiles } from "./RolesPerfiles";
import RecentActorsIcon from '@mui/icons-material/RecentActors';

export const Perfiles = () => {
    // 🌟 Define el modelo que será gestionado en este componente
    const modelo = "perfiles";

    // 🌟 Estados locales para manejar el estado del modal y el contenido del diálogo
    const [modalState, setModalState] = useState(false);
    const [dialogChild, setDialogChild] = useState("");

    /**********************************************************************
        🌟 Maneja el evento al hacer clic en el botón de roles. 
        Cambia el contenido del modal para mostrar la gestión de roles 
        asociados al perfil seleccionado. 
        - rowData: Información de la fila seleccionada en la tabla.
    **********************************************************************/
    const handleButtonClick = async (rowData) => {
        setDialogChild(<RolesPerfiles id_perfil={rowData.id}></RolesPerfiles>);
        toggleModal();
    };

    /**********************************************************************
        🌟 Define una columna adicional para la tabla de datos con el campo 
        "columna_extra_1", que muestra un ícono para administrar roles. 
        Al hacer clic en el ícono, se ejecuta `handleButtonClick` con la fila 
        seleccionada como parámetro.
    **********************************************************************/
    const columnasAdicional = [{
        field: "columna_extra_1",
        headerName: "Roles",
        flex: 1,
        headerAlign: "center",

        renderCell: (params) => (
            <Grid style={{ alignItems: 'center', textAlign: 'center', margin: 'auto' }}>
                <Tooltip title="Roles">
                    <IconButton onClick={() => handleButtonClick(params.row)}>
                        <RecentActorsIcon />
                    </IconButton>
                </Tooltip>
            </Grid>
        )
    }];

    /**********************************************************************
        🌟 Alterna el estado del modal entre abierto y cerrado.
    **********************************************************************/
    const toggleModal = () => {
        setModalState(!modalState);
    };
    
    return (
        <>
            {/**********************************************************************
                🌟 Renderiza el componente genérico ABMGenerico para gestionar perfiles.
                - modelo: Identifica el modelo gestionado ("perfiles").
                - titulo: Título de la sección.
                - columnasAdicional: Columnas adicionales específicas de este modelo.
            **********************************************************************/}
            <ABMGenerico modelo={modelo} titulo={"Perfiles"} columnasAdicional={columnasAdicional} />

            {/**********************************************************************
                🌟 Renderiza el componente SimpleDialogComponent como un modal 
                reutilizable para mostrar información detallada o gestionar roles.
                - open: Estado del modal (abierto/cerrado).
                - modalName: Nombre del modal ("Roles").
                - child: Componente hijo dinámico, definido por `dialogChild`.
                - handleClose: Función para cerrar el modal.
                - buttonEnviar y buttonCancelar: Deshabilitados en este caso.
                - maxWidth: Define el ancho máximo del modal.
            **********************************************************************/}
            <SimpleDialogComponent
                open={modalState}
                modalName={"Roles"}
                child={dialogChild}
                handleClose={toggleModal}
                buttonEnviar={false}
                buttonCancelar={false}
                maxWidth="lg"
            />
        </>
    );
};
